module.exports = __webpack_public_path__ + "static/media/400418_02.4b0425f0.png";